import { ReactNode, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { TDirection } from '@treezor/design-system';

import { SummaryInformationContent } from './SummaryInformationContent';

export type TItem = { label: string; value: ReactNode };

export type TCategory = { className?: string } & (
  | {
      component: JSX.Element;
      items?: never;
      direction?: never;
    }
  | {
      component?: never;
      items: TItem[];
      direction?: TDirection;
    }
);

export function SummaryInformationCategory({ component, items, direction = 'column', className }: TCategory) {
  return component ? (
    component
  ) : (
    <div className={twMerge('flex', direction === 'row' ? 'gap-8' : 'flex-col gap-2', className)}>
      {items.map(({ label, value }, index) => (
        <SummaryInformationContent
          key={`category-divider-${index}`}
          label={label}
          value={value}
          direction={direction === 'row' ? 'column' : 'row'}
        />
      ))}
    </div>
  );
}
